import axiosInstance from "./api_helper";

const soldeService = {
    deleteClientMovement: async (id) => axiosInstance.delete(`/api/mouvements/${id}`),
    deleteSupplierMovement: async (id) => axiosInstance.delete(`/api/fournisseur/mouvements/${id}`),
    search: async ({ clientId, dateMouvementFrom, dateMouvementTo, query }) => {
        return axiosInstance.get('/api/mouvements/search', {
            params: {
                clientId,
                dateMouvementFrom,
                dateMouvementTo,
                query
            }
        });
    },
    
    searchChantier: async ({ clientId, chantierId, dateMouvementFrom, dateMouvementTo }) => {
        return axiosInstance.get('/api/chantier/mouvements/search', {
            params: {
                clientId,
                chantierId,
                dateMouvementFrom,
                dateMouvementTo
            }
        });
    },

    searchFournisseur: async ({ fournisseurId, dateMouvementFrom, dateMouvementTo }) => {
        return axiosInstance.get('/api/fournisseur/mouvements/search', {
            params: {
                fournisseurId,
                dateMouvementFrom,
                dateMouvementTo
            }
        });
    },
    
    searchCommercial: async ({ commercialId, dateMouvementFrom, dateMouvementTo }) => {
        return axiosInstance.get('/api/commercial/mouvements/search', {
            params: {
                commercialId,
                dateMouvementFrom,
                dateMouvementTo
            }
        });
    }
};
export default soldeService;
